import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import logo from "../Assets/images/logo.png";

const Footer = () => {
  const [latestNews, setLatestNews] = useState([]);

  /* FETCH LATEST 3 NEWS */
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}product`)
      .then((res) => {
        setLatestNews(res.data.slice(0, 3));
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <footer className="bg-black text-gray-300 pt-12">
      <div className="max-w-7xl mx-auto px-4">

        {/* LINKS SECTION */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 py-12">

          {/* CATEGORIES */}
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase">
              Top Categories
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <NavLink to="/bundeli" className="hover:text-[#EC1C8C]">
                  Bundeli Chugli
                </NavLink>
              </li>
              <li>
                <NavLink to="/hindi" className="hover:text-[#EC1C8C]">
                  Hindi Chugli
                </NavLink>
              </li>
              <li>
                <NavLink to="/mp" className="hover:text-[#EC1C8C]">
                  MP News
                </NavLink>
              </li>
              <li>
                <NavLink to="/cg" className="hover:text-[#EC1C8C]">
                  CG News
                </NavLink>
              </li>
            </ul>
          </div>

          {/* USEFUL LINKS */}
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase">
              Useful Links
            </h4>
            <ul className="space-y-2 text-sm">
              <li><NavLink to="/about" className="hover:text-white">About Us</NavLink></li>
              <li><NavLink to="/privacy" className="hover:text-white">Privacy Policy</NavLink></li>
              <li><NavLink to="/terms" className="hover:text-white">Terms & Conditions</NavLink></li>
              <li><NavLink to="/contact" className="hover:text-white">Contact Us</NavLink></li>
              <li><NavLink to="/career" className="hover:text-white">Career</NavLink></li>
            </ul>
          </div>

          {/* LATEST STORIES (FROM BACKEND) */}
          <div className="lg:col-span-2">
            <h4 className="text-white font-semibold mb-4 uppercase">
              Latest Stories
            </h4>
            <ul className="space-y-3 text-sm list-disc list-inside">
              {latestNews.map((news) => (
                <li key={news.id}>
                  <NavLink
                    to={`/news/${news.id}`}
                    className="hover:text-[#EC1C8C]"
                  >
                    {news.news_title}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

       {/* SOCIAL LINKS */}
<div className="flex flex-col items-start">
  <h4 className="text-white font-semibold mb-4 uppercase text-sm">
    Follow Us
  </h4>

  <div className="flex flex-col gap-3 text-base">
    {/* Facebook */}
    <a
      href="https://www.facebook.com/profile.php?id=100063620965296"
      target="_blank"
      rel="noopener noreferrer"
      className="text-gray-300 hover:text-[#1877F2] transition"
    >
      <i className="fab fa-facebook"></i>
      <span className="ml-2">Facebook</span>
    </a>

    {/* Instagram */}
    <a
      href="https://www.instagram.com/bundeli.chugli"
      target="_blank"
      rel="noopener noreferrer"
      className="text-gray-300 hover:text-[#E4405F] transition"
    >
      <i className="fab fa-instagram"></i>
      <span className="ml-2">Instagram</span>
    </a>

    {/* X */}
    <a
      href="https://twitter.com/BundeliChugli"
      target="_blank"
      rel="noopener noreferrer"
      className="text-gray-300 hover:text-white transition"
    >
      <i className="fab fa-x-twitter"></i>
      <span className="ml-2">X</span>
    </a>

    {/* YouTube */}
    <a
      href="https://www.youtube.com/channel/UCVFaoDGdh4lDnss_BFvbLpQ"
      target="_blank"
      rel="noopener noreferrer"
      className="text-gray-300 hover:text-[#FF0000] transition"
    >
      <i className="fab fa-youtube"></i>
       <span className="ml-2">Youtube</span>
    </a>
  </div>
</div>


        </div>

        {/* COPYRIGHT */}
        <div className="border-t border-gray-900 py-4 text-center text-sm text-white">
          © 2026 Bundeli Chugli & Hindi Chugli
          <div className="text-xs text-gray-400 mt-1">
            Designed & Developed by{" "}
            <a
              href="https://yashsoftsolution.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#EC1C8C]"
            >
              Yashsoft Solution
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
